// IS_NEW_CREATIVE
// Function to check whether creative has new in search params
import { useLocation } from "react-router-dom";

export default function is_new_creative() {
  const location = useLocation();
  let isNewCreative: boolean = false;
  if (location.search !== "?new") {
    isNewCreative = false;
  }
  /**
   * HTL (20-07-23)
   * Adding check for /creative just to make sure this only returns true on an ad creator page.
   */
  if (location.pathname.includes("/creative") && location.search === "?new") {
    isNewCreative = true;
  }
  return isNewCreative;
}
